import { useTranslation } from 'react-i18next';
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { useRef, useState } from 'react';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseUpload } from '@app/components/common/BaseUpload/BaseUpload';
import { BaseSwitch } from '@app/components/common/BaseSwitch/BaseSwitch';
import config from '@app/config';
import { notificationController } from '@app/controllers/notificationController';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { Form, Space } from 'antd';
import { createVariantActionn } from '@app/store/slices/userSlice';
import { useNavigate, useNavigation } from 'react-router-dom';

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

export const ValidationFormVariantAdd: React.FC<any> = () => {
  const formRef = useRef<any>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(false);
  const [fileId, setFileId] = useState(null);
  const navigate=useNavigate();
  const [options, setOptions] = useState([{ quantity: '', unit: '' }]); // For dynamic inputs

  const onFinish = async (values: any) => {
    setLoading(true);
 
    values.values = options; // Add dynamic options to the payload

    dispatch(createVariantActionn(values))
      .unwrap()
      .then((resp: any) => {
        setLoading(false);
        if (resp.success) {
          notificationController.success({ message: t('common.success') });
          navigate('/admin/variants/list');
        } else {
          notificationController.error({ message: 'Failed to save variant' });
        }
      })
      .catch((err: any) => {
        setLoading(false);
        notificationController.error({ message: err.message });
      });
  };



  const addOption = () => {
    setOptions([...options, { quantity: '', unit: '' }]);
  };

  const removeOption = (index: number) => {
    const newOptions = options.filter((_, i) => i !== index);
    setOptions(newOptions);
  };

  const handleOptionChange = (index: number, key: string, value: string) => {
    const newOptions = [...options];
    newOptions[index][key] = value;
    setOptions(newOptions);
  };

  return (
    <>
      <Form
        {...formItemLayout}
        ref={formRef}
        name="addVariantForm"
        initialValues={{
          isActive: true,
        }}
        onFinish={onFinish}
      >
        <BaseRow gutter={[10, 10]}>
          <BaseCol xs={24} sm={12}>
            <BaseButtonsForm.Item
              name="name"
              label={'Variant Name'}
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <BaseInput />
            </BaseButtonsForm.Item>
          </BaseCol>


        </BaseRow>

        <BaseRow>
          <BaseCol span={24}>
            <Form.Item label="Variant Options">
              {options.map((option, index) => (
                <Space key={index} align="baseline" style={{marginTop:'15px',display:'flex'}}>
                  <BaseInput
                    placeholder="Size (e.g., 250,500,1, small, medium,)"
                    value={option.quantity}
                    onChange={(e) => handleOptionChange(index, 'quantity', e.target.value)}
                  />
                  <BaseInput
                    placeholder="Unit (e.g., g, kg,ml,L)"
                    value={option.unit}
                    onChange={(e) => handleOptionChange(index, 'unit', e.target.value)}
                  />
                  {options.length > 1 && (
                    <BaseButton
                      type="default"
                      danger
                      onClick={() => removeOption(index)}
                    >
                      Remove
                    </BaseButton>
                  )}
                </Space>
              ))}
              <BaseButton
                type="dashed"
                icon={<PlusOutlined />}
                onClick={addOption}
                style={{ marginTop: '10px' }}
              >
                Add Option
              </BaseButton>
            </Form.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow gutter={[10, 10]}>
          <BaseCol xs={24} sm={12} md={12} xl={6}>
            <BaseButtonsForm.Item>
              <BaseButton type="primary" htmlType="submit" loading={isLoading}>
                {t('common.submit')}
              </BaseButton>
            </BaseButtonsForm.Item>
          </BaseCol>
        </BaseRow>
      </Form>
    </>
  );
};
